import { render, staticRenderFns } from "./gradeDetailassessment.vue?vue&type=template&id=4636a892&scoped=true"
import script from "./gradeDetailassessment.vue?vue&type=script&lang=js"
export * from "./gradeDetailassessment.vue?vue&type=script&lang=js"
import style0 from "./gradeDetailassessment.vue?vue&type=style&index=0&id=4636a892&prod&scoped=true&lang=less"
import style1 from "./gradeDetailassessment.vue?vue&type=style&index=1&id=4636a892&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636a892",
  null
  
)

export default component.exports